import { create } from 'zustand';

export const useTableStoreNew = create(set => ({
  data: [],
  page: 0,
  count: 0,
  isLoading: false,
  selectedItems: {
    // id: [{ ...data }] selectedItems data model
  },
  setData: data => set({ data }),
  setPage: page => set({ page }),
  setCount: count => set({ count }),
  setIsLoading: isLoading => set({ isLoading }),
  setSelectedItemsById: (id, values) =>
    set(({ selectedItems }) => ({
      selectedItems: {
        ...selectedItems,
        [id]: values,
      },
    })),
  updateSelectedItemsByListAndId: (listId, itemId, values) => {
    set(({ selectedItems }) => {
      const currentList = selectedItems[listId].map(i => {
        if (i.id === itemId) {
          i = values;
        }
        return i;
      });

      return {
        selectedItems: {
          ...selectedItems,
          [listId]: currentList,
        },
      };
    });
  },
  deleteSelectedItemsByListAndId: (listId, itemId) => {
    set(({ selectedItems }) => {
      const currentList = selectedItems[listId].filter(i => i.id !== itemId);

      return {
        selectedItems: {
          ...selectedItems,
          [listId]: currentList,
        },
      };
    });
  },
  setSelectedItems: values =>
    set(({ selectedItems }) => ({
      selectedItems: {
        ...selectedItems,
        ...values,
      },
    })),
}));
